import { Component, inject } from '@angular/core';

import { ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { AppIconComponent } from '../../../common/components/icon/icon.component';
import { Router } from '@angular/router';
import { HeaderHomeComponent } from '../../../common/components/header-home/header-home.component';
import { InsuranceCategory } from '../../../core/data/dtos/insurance-type.dto';
import { AuthService } from '../../auth/services/auth.service';
import { QuotesService } from '../../../core/data/services/quotes.service';
import { SwalService } from '../../../common/services/swal.service';

@Component({
  selector: 'app-home',
  imports: [ReactiveFormsModule, HeaderHomeComponent, AppIconComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent {
  showQuoteModal = false;
  form: FormGroup;
  readonly Category = InsuranceCategory;

  private readonly auth = inject(AuthService);
  private readonly quotes = inject(QuotesService);
  private readonly swal = inject(SwalService);
  private readonly fb = inject(FormBuilder);

  constructor(private readonly router: Router) {
    this.form = this.fb.group({
      quoteNumber: ['', [Validators.required]],
      quoteEmail: ['', [Validators.required, Validators.email]],
    });
  }

  get isLoggedIn(): boolean {
    return !!this.auth.authToken;
  }

  get userFullName(): string {
    const u: any = (this.auth as any).user;
    return (
      u?.idTokenClaims?.given_name ||
      u?.name ||
      u?.username ||
      ''
    );
  }

  openQuoteModal(): void {
    this.showQuoteModal = true;
  }

  closeQuoteModal(): void {
    this.showQuoteModal = false;
    this.form.reset();
  }

  onSearchQuote(): void {
    if (this.form.invalid) {
      return;
    }

    const { quoteNumber, quoteEmail } = this.form.value;
    const id = Number(quoteNumber);
    if (Number.isNaN(id)) {
      this.swal.error('El número de cotización no es válido');
      return;
    }

    this.swal.showLoading('Buscando cotización...');
    this.quotes.getQuote(id, quoteEmail).subscribe({
      next: (_) => {
        this.swal.dismiss();
        // Quote has been stored in session by the service
        this.closeQuoteModal();
        // Optionally navigate to resume the flow if needed
        void this.router.navigate(['/quote/summary']);
      },
      error: (err) => {
        console.error('Error fetching quote', err);
        this.swal.error('No se encontró la cotización. Verifica los datos e intenta de nuevo.');
      },
      complete: () => {
        this.swal.dismiss();
      },
    });
  }

  selectInsuranceCategory(category: InsuranceCategory): void {
    void this.router.navigate(['/quote/insurance-types'], {
      queryParams: { category },
    });
  }
}
